<template>
  <div class="borderWrap" :style="isInModal && 'border: none'">
    <graph-header
      :title="title"
      :data-filter="dataFilter"
      :value="value"
      :end-date="endDate"
      :start-date="startDate"
      :initial-date-range-option="initialDateRangeOption"
      :initial-date-range="initialDateRange"
      :is-in-modal="isInModal"
      :report-radio-buttons-title="reportRadioButtonsTitle"
      :date-filter-options="dateFilterOptions"
      :max-date-range="maxDateRange"
      :allow-all-time="allowAllTime"
      :all-time-date-range="allTimeDateRange"
      :preset-end-date="presetEndDate"
      :range-type="rangeType"
      :total-label="headerTotalLabel"
      @changeDateRange="changeDateRange($event)"
      @closeModal="$emit('closeModal')"
    >
      <slot name="value" />
    </graph-header>
    <div class="graph-container" :style="isInModal && 'padding: 0'">
      <div v-if="!hasData" class="no-data-title">{{ adminText(&quot;shellAll.no_data_for_selected_period&quot;, &quot;No data for selected period.&quot;) }}</div>
      <slot v-else />
    </div>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import GraphHeader from './graph-header.vue'
import { DatePickerRangeType } from '@/types'
export default {
  mixins: [AdminContext],
  name: 'graph',
  components: { GraphHeader },
  props: {
    dataFilter: {
      type: Boolean,
      default: false,
    },
    title: String,
    value: String,
    startDate: String,
    endDate: String,
    hasData: Boolean,
    initialDateRangeOption: Number,
    initialDateRange: Array,
    isInModal: Boolean,
    reportRadioButtonsTitle: String,
    dateFilterOptions: Array,
    maxDateRange: Number,
    allowAllTime: Boolean,
    allTimeDateRange: Array,
    presetEndDate: String,
    rangeType: {
      type: String,
      default: DatePickerRangeType.DATE,
    },
    headerTotalLabel: String,
  },
  methods: {
    changeDateRange(dateRangeObject) {
      this.$emit('changeDateRange', dateRangeObject)
    },
  },
}
</script>

<style scoped>
.graph-container {
  min-width: 0;
  overflow: hidden;
  padding: 0px 20px 36px 20px;
}
.borderWrap {
  border: 1px #f5f5f5 solid;
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;
  min-width: 0;
  overflow: hidden;
  width: 100%;
  flex-direction: column;
  height: 100%;
}

.no-data-title {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  height: 100%;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.8px;
  color: #979797;
  margin-bottom: 25px;
}
</style>
